import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { isAppPath } from "@/lib/app-paths";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    // LDT-717 · Título propio y `noindex`: antes una URL inexistente dejaba el
    // <head> de la home (título y canónica) y Google la tomaba por otra copia
    // de la portada. Vercel ya la sirve con 404 (dist/404.html); esto cubre la
    // navegación dentro de la web y el service worker, que la sirve desde el
    // app shell. Fuera del panel, con la tipografía de marca, como el resto de
    // la ruta pública; dentro, como estaba.
    <div
      className={`${isAppPath(location.pathname) ? "" : "playium-brand-fonts "}flex min-h-screen items-center justify-center bg-muted`}
    >
      <Helmet>
        <title>404 — Playium</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
